import { Component, Input } from '@angular/core';
import { CampaignPreviewModalComponent } from '@pages/content-locker/available-campaigns-locker/campaign-preview-modal/campaign-preview-modal.component';
import { ISingleCampaign } from '@app/core/models/core-models';
import { CAMPAIGN_PREVIEW_VIEW_TYPE } from '@pages/content-locker/available-campaigns-locker/campaign-preview-modal/campaign-preview.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-open-details-modal-button',
  templateUrl: './open-details-modal-button.component.html',
  styleUrl: './open-details-modal-button.component.scss'
})
export class OpenDetailsModalButtonComponent {
  @Input() data?: ISingleCampaign;

  constructor(private modalService: NgbModal) {}

  public openDetails(event: MouseEvent) {
    event.stopPropagation();

    this.openModal('', 'view_translations.campaign_details', 'campaign');
  }

  private openModal(modalDescription: string, modalTitle: string, modalType: string): void {
    const modalRef = this.modalService.open(CampaignPreviewModalComponent, {
      size: 'me'
    });

    const componentInstance = modalRef.componentInstance as CampaignPreviewModalComponent;

    // componentInstance.campaignData = this.campaign as ISingleCampaign;
    componentInstance.campaignData = this.data;
    componentInstance.modalDescriptionName = modalDescription;
    componentInstance.modalTitle = modalTitle;
    componentInstance.modalType = modalType;
    componentInstance.smartlinks = true;

    (componentInstance as CampaignPreviewModalComponent).viewType = CAMPAIGN_PREVIEW_VIEW_TYPE.campaigns;
  }
}
